// extracted by mini-css-extract-plugin
export default {"formGroup":"EditCampaignModal_formGroup__B7ka8"};